import React from 'react';
import Hero from './Hero';
import Project from './Project';
import ProjectSlider from './ProjectSlider';
import Social from './Social';
import Testimonal from './Testimonal';

const Home = () => {
    return (
        <>
            <Hero />
            <Project />
            <ProjectSlider />
            <Testimonal />
            <Social />
        </>
    );
};

export default Home;